(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name CursosController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('CursosController', CursosController);

    CursosController.$inject = ["CursosService","$timeout","$location",'$anchorScroll','$uibModal','$window','AnaliticaService'];

    function CursosController(CursosService,$timeout,$location,$anchorScroll,$uibModal,$window,AnaliticaService)
    {

    	var vm = this;

      vm.initVar = true;
      vm.currentEdicion = {};
    	vm.loading = false;
        vm.filtros = {};
        vm.ediciones = [];
        //console.log("cursos");
        vm.startDate = new Date();
    	  vm.endDate = new Date();
    	  vm.endDate.setDate(vm.endDate.getDate() + 5);
    	  

        vm.buscarFiltros = function(){
          
            var url_string = window.location.href
            var url = new URL(url_string);
            if($location.search().tematicas){
                vm.filtros.tematicas = $location.search().tematicas;
            }
            if($location.search().subtematicas){
                vm.filtros.subtematicas = $location.search().subtematicas;
            }


            if($location.search().pais){
                vm.filtros.pais = $location.search().pais;
            }

            if($location.search().ano){
                vm.filtros.ano = $location.search().ano;
            }
             if($location.search().buscador){
                vm.filtros.buscador = $location.search().buscador;
            }
            console.log($location.search().vista);

             if($location.search().vista){
                vm.filtros.vista = $location.search().vista;
            }
            console.log($location.search().mes);

            if($location.search().mes){
            console.log("MES");
                vm.filtros.mes = $location.search().mes;
                $timeout(function(){
                   var dateIn = new Date(vm.filtros.ano,parseInt(vm.filtros.mes)-1,"01");
                    vm.currentDate = dateIn;
                })
               
                return true;
            }
            return false;

        }

        vm.getCursos = function(init){
          console.log("GET CURSOS");
        	vm.loading = true;
          if(vm.initVar){
              var resF = vm.buscarFiltros();
              console.log(resF);
              if(resF){
                vm.initVar = false;
                return false;
              }
          }
          
        	vm.ediciones = [];
          CursosService.getCursos(vm.filtros,function(data){
            console.log(data);
            console.log(vm.initVar);
              if(!vm.initVar){
                  var queryParams = new URLSearchParams(window.location.search);
                   
                  // Set new or modify existing parameter value. 
                  //queryParams.set("page", vm.page);
                  if(vm.filtros.tematicas){
                      queryParams.set("tematicas", vm.filtros.tematicas);
                  }else{
                      queryParams.delete("tematicas");
                  }

                  if(vm.filtros.subtematicas){
                      queryParams.set("subtematicas", vm.filtros.subtematicas);
                  }else{
                      queryParams.delete("subtematicas");
                  }
                  if(vm.filtros.pais){
                      queryParams.set("pais", vm.filtros.pais);
                  }else{
                      queryParams.delete("pais");
                  }
                  if(vm.filtros.ano){
                      queryParams.set("ano", vm.filtros.ano);
                  }else{
                      queryParams.delete("ano");
                  }
                  console.log(vm.currentDate);
                  if(vm.filtros.mes){
                      queryParams.set("mes", vm.filtros.mes);
                  }else{
                      queryParams.delete("mes");
                  }

                   if(vm.filtros.buscador){
                      queryParams.set("buscador", vm.filtros.buscador);
                  }else{
                      queryParams.delete("buscador");
                  }

                  if(vm.filtros.vista){
                      queryParams.set("vista", vm.filtros.vista);
                  }else{
                      queryParams.delete("vista");
                  }
                  // Replace current querystring with the new one.
                  $location.url( "?"+queryParams.toString());
              }
              vm.ediciones = data.ediciones;
              vm.loadEvents();
              vm.loading = false;
              vm.initVar = false;

          });
        }

        function formattedDate(day) {
            var daySplit = day.split("-");
            //console.log(daySplit);
            //console.log(parseInt(daySplit[1])-1);
            var dateForm = new Date(daySplit[2], parseInt(daySplit[1])-1, daySplit[0]);
            dateForm.setDate(dateForm.getDate() + 1);
            return dateForm
          
        }

    vm.changeMes = function(init){
      //var dateIn = new Date(vm.filtros.ano,parseInt(vm.filtros.mes)-1,"01");
      //vm.currentDate = dateIn;
      //if(vm.filtros.vista!='calendario'){
        vm.getCursos(init);
      //}
    }

    vm.loadEvents = function () {
        vm.eventSource = createEvents();
    };

    vm.rangeChanged = function (startTime, endTime) {
    	var dateIn = new Date(vm.currentDate);
    	//console.log(vm.currentDate);
    	//console.log(dateIn)
    	//console.log(dateIn.getMonth()+1);
    	vm.filtros.mes = ""+(dateIn.getMonth()+1 <= 9 ? '0':'')+(dateIn.getMonth()+1);
    	vm.filtros.ano = ""+dateIn.getFullYear();
    	//console.log(startTime);
    	//console.log(endTime);
    	vm.getCursos(false);
      /*Events.query({startTime: startTime, endTime: endTime}, function(events){
          $scope.eventSource=events;
      });*/
  	};


      vm.getSubtematicas = function(){
        CursosService.getSubtematicas(vm.filtros.tematicas,function(data){
            vm.subtematicas = data.subtematicas;
        });
      }
    vm.onEventSelected = function (event) {
        vm.event = event;
        console.log(event);
    };
    vm.querymode="remote";

    vm.onTimeSelected = function (selectedTime, events) {
      vm.currentEdicion = events[0];
                    $("html, body").animate({ scrollTop: $('.cur_'+events[0].id).offset().top - 115 }, 1000);
        //console.log('Selected time: ' + selectedTime + ' hasEvents: ' + (events !== undefined && events.length !== 0));
    };

    function createEvents() {
        var events = [];
        for(var cont = 0;cont<vm.ediciones.length;cont++){
        	var dateFechaIni = formattedDate(vm.ediciones[cont].fecha_inicio);
        	//console.log(dateFechaIni.getDate());
        	//var dateFechaFin = formattedDate(vm.ediciones[cont].fecha_inicio);
        	events.push({
                title: vm.ediciones[cont].titulo,
                id:vm.ediciones[cont].id,
                startTime: dateFechaIni,
                endTime: dateFechaIni,
                allDay: true
            });
        }
        //console.log(events);
        return events;
    }




    vm.inscripcionModal = "";
    vm.abrirInscripcion = function(edicion_id,nombre){
        vm.inscripcionModal = $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-top',
              ariaDescribedBy: 'modal-body-top',
              templateUrl: 'inscripcion.html',
              size: 'lg',
              //backdrop:'static',
              controller: function($scope) {
                  $scope.edicion_id = edicion_id;
                  $scope.nombre = nombre;
                $timeout(function(){
                      $.material.checkbox();
                    },100)
                $timeout(function(){
                      $('select').select2();
                    },400)
                $scope.okForm = function(){
                    vm.inscripcionModal.close();
                }
               
              }
        });
        AnaliticaService.pageView('Solicitud info: '+nombre,$window.location.pathname+'/form-sinfo',$window.location.pathname+'/form-sinfo');

    }
    vm.solicitudModal = "";
    vm.abrirSolicitud = function(curso_id,nombre){
        vm.solicitudModal = $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-top',
              ariaDescribedBy: 'modal-body-top',
              templateUrl: 'solicitud.html',
              size: 'lg',
              //backdrop:'static',
              controller: function($scope) {
                $scope.curso_id = curso_id;
                $scope.nombre = nombre;
                $timeout(function(){
                      $.material.checkbox();
                    },100)
                $timeout(function(){
                      $('select').select2();
                    },400)
                $scope.okForm = function(){
                    vm.solicitudModal.close();
                }
               
              }
        });
        AnaliticaService.pageView('Solicitud interés: '+nombre,$window.location.pathname+'/form-sinteres',$window.location.pathname+'/form-sinteres');
    }


      //vm.getCursos();

       
    }


})();